import React from "react";
import { Box, Badge, alpha, useTheme } from "@mui/material";
import { ShoppingCart } from "@mui/icons-material";
import { LUXURY } from "data/guestLuxuryTheme";

const FloatingCartButton = ({ luxury = false, cartItemCount, onClick }) => {
  const theme = useTheme();

  if (cartItemCount === 0) return null;

  if (luxury) {
    return (
      <Box
        component="button"
        onClick={onClick}
        sx={{
          appearance: "none",
          position: "fixed",
          bottom: { xs: 20, md: 24 },
          right: { xs: 20, md: 24 },
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          gap: 0.85,
          height: 56,
          px: 1.8,
          border: 0,
          cursor: "pointer",
          borderRadius: "28px",
          bgcolor: LUXURY.forest,
          color: LUXURY.cream,
          boxShadow: "0 16px 32px rgba(28,25,23,0.28)",
          WebkitTapHighlightColor: "transparent",
          "&:active": { transform: "scale(0.98)" },
        }}
      >
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: "22px",
            background: LUXURY.ctaGradient,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: LUXURY.ctaShadow,
          }}
        >
          <ShoppingCart sx={{ fontSize: 18, color: LUXURY.forestDeep }} />
        </Box>
        <Box sx={{ fontWeight: 800, fontSize: "0.88rem", letterSpacing: "-0.02em" }}>
          Cart
        </Box>
        <Box
          sx={{
            minWidth: 22,
            height: 22,
            px: 0.6,
            borderRadius: 999,
            bgcolor: LUXURY.gold,
            color: LUXURY.forest,
            fontSize: "0.72rem",
            fontWeight: 800,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {cartItemCount}
        </Box>
      </Box>
    );
  }

  return (
    <Box
      component="button"
      onClick={onClick}
      sx={{
        appearance: "none",
        position: "fixed",
        bottom: { xs: 20, md: 24 },
        right: { xs: 20, md: 24 },
        width: { xs: 60, md: 64 },
        height: { xs: 60, md: 64 },
        border: 0,
        cursor: "pointer",
        borderRadius: "50%",
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
        boxShadow: `0 8px 24px ${alpha(theme.palette.primary.main, 0.4)}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        transition: "all 0.3s ease",
        "&:hover": {
          background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.secondary.dark} 100%)`,
          transform: "scale(1.1)",
        },
      }}
    >
      <Badge badgeContent={cartItemCount} color="error">
        <ShoppingCart sx={{ fontSize: { xs: 26, md: 28 }, color: "white" }} />
      </Badge>
    </Box>
  );
};

export default FloatingCartButton;
